// import logo from './logo.svg';
import "./App.css";
import Header from "./Components/Header.js";
import Footer from "./Components/Footer.js";
import Home from "./Pages/Home.js";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <div>
      <header className="header-section">
        <Header />
      </header>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="other" element={<Footer />} />
      </Routes>
      {/* <footer> */}
      <Footer />
      {/* </footer> */}
    </div>
  );
}

export default App;
